function CategoryDescription({
  description
}) {
  return <div className="text-supportiveBlack rtl:font-arabic mx-auto flex w-full flex-col p-4 text-justify text-base md:px-0 md:text-center" dangerouslySetInnerHTML={{
    __html: description
  }} data-sentry-component="CategoryDescription" data-sentry-source-file="CategoryDescription.jsx" />;
}
export default CategoryDescription;